import { overlay } from 'overlay-kit';
import { openOverlayOnceAsync, prepareOverlayOnce } from '@/shared/utils/openOverlayOnce';
import type { FolderQuizPickerModalProps } from './components/FolderQuizPickerModal';
const OVERLAY_ID = 'folder-quiz-picker-modal';

/**
 * 폴더에 담을 퀴즈를 고르는 모달을 연다. 닫힐 때 resolve 된다.
 *
 * 담긴 결과는 `addQuiz` 로 받는다 — 담아도 모달은 열려 있어 여러 개를 이어서 담는다.
 */
export async function showFolderQuizPickerModal(options: Omit<FolderQuizPickerModalProps, 'onClose'>) {
  const loaded = await prepareOverlayOnce(OVERLAY_ID, () => import('./components/FolderQuizPickerModal'));
  if (!loaded) return;
  const {
    FolderQuizPickerModal
  } = loaded;
  await openOverlayOnceAsync<void>(OVERLAY_ID, ({
    close
  }) => <FolderQuizPickerModal {...options} onClose={() => close()} />);
  overlay.unmount(OVERLAY_ID);
}